module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//16.jpg?34bf38223f240a918e1740544b4615ba";